import React from 'react';

import sadIcon from 'assets/icons/raffledetails/sad.png';
import Addr from './Addr';

const NotWon = () => {
  return (
    <div>
      <div className="flex items-center justify-center gap-3">
        <img src={sadIcon.src} className="w-8" alt="" />
        <div className="text-xl font-semibold text-neutral-100">
          You&apos;re not winner
        </div>
      </div>
      <div className="mt-1 text-center text-sm font-normal text-neutral-300">
        Maybe next time!
      </div>
      <div className="mt-4">
        <Addr />
      </div>
    </div>
  );
};

export default NotWon;
